// @ constants
const actionTypes = require('constants/actionTypes');
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
// @vendors
const get = require('lodash/object/get');

const getContractAddressRequest = () => ({
    type: actionTypes.GET_CONTRACT_ADDRESS_REQUEST,
});

const getContractAddressSuccess = contractAddress => ({
    type: actionTypes.GET_CONTRACT_ADDRESS_SUCCESS,
    payload: {
        contractAddress
    }
});

const getContractAddressNoResultSuccess = () => ({
    type: actionTypes.GET_CONTRACT_ADDRESS_NO_RESULT_SUCCESS,
});

const getContractAddressError = errorDescription => ({
    type: actionTypes.GET_CONTRACT_ADDRESS_ERROR,
    payload: {
        errorDescription
    }
});

const getContractAddress = () => (dispatch) => {
    dispatch(getContractAddressRequest());

    const requestData = {
        query : {}
    }

    return APIPost({
        dispatch,
        endpoint : 'getContractAddress',
        params : requestData
    })
    .then(response => {
        const contractAddress = get(response, 'domicilios[0]');

        if (!!contractAddress) {
            dispatch(getContractAddressSuccess(contractAddress));
        } else {
            dispatch(getContractAddressNoResultSuccess());
        }
    })
    .catch(response => {
        if (!!response.error) {
            dispatch(getContractAddressError(response.error));
        } else {
            throw response;
        }
    });
};

module.exports = {
    getContractAddress
};
